/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../component/component';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "printable_check": {
                "nested": {
                  "PrintableCheckTextInput": {
                    "fields": {
                      "description": {
                        "type": ".squareup.bbfrontend.common.component.TextInputDescription",
                        "id": 1,
                        "rule": "optional"
                      },
                      "lengthRange": {
                        "type": ".squareup.bbfrontend.common.printable_check.PrintableCheckTextInput.TextLengthRange",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "TextLengthRange": {
                        "fields": {
                          "minimum": {
                            "type": "int32",
                            "id": 1,
                            "rule": "optional"
                          },
                          "maximum": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.PrintableCheckTextInput && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.PrintableCheckTextInput?.nested?.TextLengthRange) {
  $root.addJSON(jsonData);
}

/**
 * Wrapper around TextInputDescription to encapsulate min/max range.
 *
 * SOURCE PrintableCheckTextInput @ squareup/bbfrontend/common/printable_check/printable_check_input.proto at 13:1
 */
export const PrintableCheckTextInput = $root.lookupType('squareup.bbfrontend.common.printable_check.PrintableCheckTextInput');
fixType(PrintableCheckTextInput, {
  description: {
    required: true
  }
});
Builder.createAndAttachToType(PrintableCheckTextInput);
/**
 * SOURCE TextLengthRange @ squareup/bbfrontend/common/printable_check/printable_check_input.proto at 17:3
 */
PrintableCheckTextInput.TextLengthRange = $root.lookupType('squareup.bbfrontend.common.printable_check.PrintableCheckTextInput.TextLengthRange');
fixType(PrintableCheckTextInput.TextLengthRange);
Builder.createAndAttachToType(PrintableCheckTextInput.TextLengthRange);